import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import Page from 'components/pages/Base/Page/Page';

const StyledUsersSettingPage = styled(Page)`
  ${ComponentStyles}
`;

StyledUsersSettingPage.propTypes = {
  theme: PropTypes.object
};

export default StyledUsersSettingPage;
